module.exports = __webpack_public_path__ + "static/green-black-gradient-bg-a079df7b7f1439c50dffe67417a6a055.png";